.productCardFormInfo {
  display: none;
}

.productCardFormWeights {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.productCardFormWeightsTitle {
  display: none;
}

.productCardFormWeightsButton {
  width: 45%;
  flex-grow: 1;
}

.productCardFormWeightDealsText {
  color: var(--colors-info-main);
}

.productCardFormWeightsButtonLabel {
  display: flex;
  gap: 4px;
  color: var(--colors-grays-dark);
}

.productCardAddToCartForm {
  width: 100%;
}

.textContrastColor {
  color: var(--colors-text-inverse);
}

@media all and (--reefer-media-tablet-min) {
  .productCardFormInfo {
    display: flex;
    align-items: center;
    gap: 24px;
    min-width: 512px;
  }

  .productCardFormWeightsTitle {
    display: block;
  }
}
